"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopupService = void 0;
const typedi_1 = require("typedi");
const lit_html_1 = require("lit-html");
const emitter_1 = require("@event/services/emitter");
const type_1 = require("@event/type");
/**
 * Конртроллер всплывающих окон
 */
let PopupService = class PopupService {
    /**
     * Конструктор
     */
    constructor() {
        /**
         * Шаблоны
         */
        this.templates = new Map();
        this.containerClasses = ['art-uikit', 'art-modal-container'];
        this.currentInit = null;
        /**
         * Окно инициализировано
         */
        this.inited = false;
        /**
         * Смена окон
         */
        this.switching = false;
        this.eventEmitter = typedi_1.Container.get(emitter_1.EventEmitter);
    }
    /**
     * Регистрирует шаблон
     */
    registerTemplate(name, templateGenerator) {
        this.templates.set(name, templateGenerator);
    }
    /**
     * Проверяет есть ли открытые окна
     */
    isOpened() {
        return !!this.getContainer();
    }
    /**
     * Возвращает текущую инициализацию
     */
    getCurrentInit() {
        return this.currentInit;
    }
    /**
     * Возвращает контейнер модального окна
     */
    getContainer() {
        const children = document.body.children;
        for (let i = 0; i < children.length; i++) {
            const item = children.item(i);
            if (!item) {
                continue;
            }
            if (this.containerClasses.some((className) => item.classList.contains(className))) {
                return item;
            }
        }
        return null;
    }
    /**
     * Открывает модальное окно
     */
    open(name, params, scenario) {
        return __awaiter(this, void 0, void 0, function* () {
            const templateGenerator = this.templates.get(name);
            if (!templateGenerator) {
                return;
            }
            const isOpened = this.isOpened();
            if (isOpened) {
                this.switching = true;
            }
            if (isOpened && (yield this.waitShown())) {
                yield this.close();
            }
            let container = this.getContainer();
            if (!container) {
                container = yield this.initContainer();
            }
            const template = templateGenerator(params);
            (0, lit_html_1.render)(template, container);
            yield new Promise((resolve) => setTimeout(resolve, 50));
            this.modalElement = container.querySelector('.modal');
            this.modalInstance = window.Modal.getOrCreateInstance(this.modalElement);
            this.modalInstance.show();
            this.currentInit = { name, params };
            this.modalElement.addEventListener('shown.bs.modal', () => {
                this.inited = true;
            });
            this.modalElement.addEventListener('hidden.bs.modal', () => {
                if (!this.switching) {
                    this.eventEmitter.emit(type_1.EventType.MODAL_CLOSED);
                }
                this.switching = false;
                this.inited = false;
                this.modalInstance.dispose();
                this.modalInstance = null;
                this.modalElement = null;
                this.currentInit = null;
                container && container.remove();
            });
            if (scenario !== undefined) {
                this.setPopupDataScenario(scenario);
            }
        });
    }
    /**
     * Закрывает окно
     */
    close() {
        this.removePopupDataScenario();
        return new Promise((resolve) => {
            if (this.modalElement) {
                this.modalElement.addEventListener('hidden.bs.modal', resolve);
                this.modalInstance.hide();
                return;
            }
            resolve();
        });
    }
    /**
     * Ждет полного отображения окна
     */
    waitShown() {
        return __awaiter(this, void 0, void 0, function* () {
            while (!this.inited) {
                yield new Promise((resolve) => setTimeout(resolve, 50));
            }
            return true;
        });
    }
    /**
     * Инициализирует контейнер
     */
    initContainer() {
        return __awaiter(this, void 0, void 0, function* () {
            const container = document.createElement('div');
            container.classList.add(...this.containerClasses);
            document.body.append(container);
            return container;
        });
    }
    /**
     * Отключает простыню бутстраповских + пределанных бутстраповских стилей на UI-KIT
     */
    toggleArtScheme(parentElement) {
        if (!!parentElement && parentElement.classList.contains('art-uikit')) {
            parentElement === null || parentElement === void 0 ? void 0 : parentElement.classList.remove('art-uikit');
        }
        parentElement === null || parentElement === void 0 ? void 0 : parentElement.classList.add('art-uikit-popup');
    }
    /**
     * Присваивает дата параметр data-scenario у всплывающего окна
     */
    setPopupDataScenario(name) {
        let wrapper = document.querySelector('.art-modal-container');
        if (wrapper !== null) {
            wrapper.setAttribute('data-scenario', name);
        }
    }
    /**
     * Удаляет дата параметр data-scenario у всплывающего окна
     */
    removePopupDataScenario() {
        let wrapper = document.querySelector('.art-modal-container');
        if (wrapper !== null) {
            wrapper.removeAttribute('data-scenario');
        }
    }
};
PopupService = __decorate([
    (0, typedi_1.Service)(),
    __metadata("design:paramtypes", [])
], PopupService);
exports.PopupService = PopupService;
